import React, { Component, MouseEvent } from "react";
import acolor from "./Images/acolor.jpeg";
import dcolor from "./Images/dcolor.jpeg";
import scolor from "./Images/scolor.jpg";

type ResultPageProps = {
    // asks parent to begin quiz
    onRestartClick: () => void;

    // score
    score: number[];
}

export class ResultPage extends Component<ResultPageProps> {
    render = (): JSX.Element => {
        return (
            <div>
                <h1>{this.renderResult()}</h1>
                <button type="button" onClick={this.doRestartClick}>Restart Quiz</button>
            </div>
        );
    }

    // Updates UI to quiz page
    doRestartClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onRestartClick();
    }

    // find the result
    findResult = (): number => {
        const result = Math.max(this.props.score[1], Math.max(this.props.score[0], this.props.score[2]));
        return result;
    }

    // Display result
    renderResult = (): JSX.Element => {
        const result = Math.max(this.props.score[1], Math.max(this.props.score[0], this.props.score[2]));
        if (this.props.score.indexOf(result) === 0) {
            return (
                <div>
                    <h1>You are A Spritz!</h1>
                    <p></p>
                    <img src={acolor} className = "final" alt="macaron"/>
                </div>
            );
        } else if (this.props.score.indexOf(result) === 1) {
            return (
                <div>
                    <h1>You are Deep Sea!</h1>
                    <p></p>
                    <img src={dcolor} className="final" alt="dog"/>
                </div>
            )
        } else {
            return (
                <div>
                    <h1>You are Silver Linings!</h1>
                    <p></p>
                    <img src={scolor} className="final" alt="dog"/>
                </div>
            )
        }
    }
}